<template>
  <div class="container" v-if="userDetails !== null">
    <section class="section">
      <img
        class="twitter_photo"
        :src="userDetails.user.providerData[0].photoURL"
      />
      <span class="user_details">
        {{ userDetails.user.displayName }}
        @{{ userDetails.additionalUserInfo.username }}
      </span>
      <br />
      list recent logins to the app
    </section>
    <section class="section1">
      <!-- list recent pages created with delete button -->
      <button @click.prevent="refresh">refresh icon</button>
      <div v-if="posts.length === 0">
        It's lonely here!
        <br />
        Try out our tweet contrast.
      </div>
      <div v-else>
        <div v-for="(post, index) in posts" :key="index" :ref="'s3' + index">
          <!-- <a :href="post.post_url">{{post.post_url}}</a> -->
          <button
            class="delete_page"
            @click.prevent="delete_page('s3L' + index)"
          >
            del icon</button
          >{{ post.created_at }},
          <a :ref="'s3L' + index" :href="post.entities.urls[0].expanded_url">{{
            post.entities.urls[0].expanded_url
          }}</a>
          #{{ post.entities.hashtags[0].text }}
        </div>
      </div>
    </section>
    <section class="section2">
      Thanks for using Slow Band!
      <br />
      <em>
        Trying to raise awareness of the digital divide by contrasting
        experiences.</em
      >
    </section>
  </div>
  <div v-else>
    <section class="section">
      Public Contrasts
    </section>
    <section class="section1">
      list public contrasts here
    </section>
    <section class="section2">
      Thanks for using Slow Band!
      <br />
      <em>
        Trying to raise awareness of the digital divide by contrasting
        experiences.</em
      >
    </section>
  </div>
</template>

<script>
/*eslint-disable*/
import { mapGetters, mapActions } from 'vuex';
import axios from 'axios';  
import query_posts from "../queries/posts.js";

export default {
    data(){
        return {
          user: this.getUser,
          posts: [],
          token:''
        }
    },
    computed:{
      ...mapGetters(['getUser', 'getRecentTweets', 'getToken']),
      userDetails(){
        return this.getUser;
      },
      twitter_timeline(){
        return this.posts;
      }

    },
    mounted(){
      this.user = this.getUser;
      localStorage.setItem('user', this.user.additionalUserInfo.username);
      this.token = this.getToken;
      this.twitterFeed();
    },
    beforeUpdate(){
      this.twitterFeed();
    },
    methods:{
      ...mapActions(['getPosts','getApiTweets']),
      twitterFeed: function() {
        this.getApiTweets(this.user.additionalUserInfo.username);
        this.posts = this.getRecentTweets;
      },
      delete_page(page){
        let idx = page.replace('s3L',"");
        let tweetId = this.posts[Number(idx)].id_str;
        let link = this.$refs[page][0].innerText;
        let name = link.split("/");
        let to_remove = name[name.length-1];
        const formdata = new FormData();
        formdata.append('name', to_remove);
        formdata.append('tweet_id', tweetId);
        axios.post("http://slow-band-v1.herokuapp.com/api/remove", formdata).then(res =>{
                if (res.data === "deleted"){
                  this.posts.splice(Number(idx),1);
                }
            });
      },
      refresh(){
        this.twitterFeed();
      }
    }
    
}
</script>
<style lang="sass">
$font-stack:    Arial, sans-serif
$primary-color: #333


.twitter_photo
  border-color: rgba(0,0,0,0.04)
  border-width: 3px;
  border-radius: 9999px;

.user_details
  text-align: center
  vertical-align: top

.delete_page
  color: red
  // font-size: 20px

</style>